import { all_routes } from "../../../feature-module/router/all_routes";

const route = all_routes;

export interface HeaderButton {
  type: "app" | "report";
  label: string;
  link: string;
  icon: string;
  bg: string; 
}

export const HeaderButtons: Record<
  "user" | "admin" | "superadmin" | "client",
  HeaderButton[]
> = {
  user: [
    {
      type: "app",
      label: "Contacts",
      link: route.contactList,
      icon: "ti ti-user-up",
      bg: "bg-violet",
    },
    {
      type: "app",
      label: "Leads",
      link: route.leads,
      icon: "ti ti-chart-arcs",
      bg: "bg-secondary",
    },
    {
      type: "app",
      label: "Quotes",
      link: route.ProposalsList,
      icon: "ti ti-file-star",
      bg: "bg-success",
    },
    {
      type: "app",
      label: "Deals",
      link: route.deals,
      icon: "ti ti-medal",
      bg: "bg-dark",
    },
    {
      type: "app",
      label: "Invoices",
      link: route.InvoiceList,
      icon: "ti ti-file-invoice",
      bg: "bg-pink",
    },
    {
      type: "app",
      label: "Campaign",
      link: route.campaign,
      icon: "ti ti-brand-campaignmonitor",
      bg: "bg-green",
    },
    {
      type: "app",
      label: "Calendar",
      link: route.calendar,
      icon: "ti ti-calendar",
      bg: "bg-danger",
    },
    {
      type: "app",
      label: "Todo",
      link: route.todo,
      icon: "bi bi-card-checklist",
      bg: "bg-tertiary",
    },
    {
      type: "app",
      label: "Notes",
      link: route.notes,
      icon: "bi bi-journal-bookmark",
      bg: "bg-green",
    },
    {
      type: "app",
      label: "Activities",
      link: route.activities,
      icon: "ti ti-bounce-right",
      bg: "bg-pink",
    },
  ],

  admin: [
    {
      type: "app",
      label: "Contacts",
      link: route.contactList,
      icon: "ti ti-user-up",
      bg: "bg-violet",
    },
    {
      type: "app",
      label: "Leads",
      link: route.leads,
      icon: "ti ti-chart-arcs",
      bg: "bg-secondary",
    },
    {
      type: "app",
      label: "Quotes",
      link: route.ProposalsList,
      icon: "ti ti-file-star",
      bg: "bg-success",
    },
    {
      type: "app",
      label: "Deals",
      link: route.deals,
      icon: "ti ti-medal",
      bg: "bg-dark",
    },
    {
      type: "app",
      label: "Invoices",
      link: route.InvoiceList,
      icon: "ti ti-file-invoice",
      bg: "bg-pink",
    },
      {
      type: "app",
      label: "Activities",
      link: route.activities,
      icon: "ti ti-bounce-right",
      bg: "bg-pink",
    },
    // {
    //   type: "app",
    //   label: "Campaign",
    //   link: route.campaign,
    //   icon: "ti ti-brand-campaignmonitor",
    //   bg: "bg-green"
    // },
    
    // {
    //   type: "app",
    //   label: "Call Log",
    //   link: route.callSettings,
    //   icon: "ti ti-phone-call",
    //   bg: "bg-indigo" 
    // },
    // {
    //   type: "app",
    //   label: "Pipeline",
    //   link: route.pipeline,
    //   icon: "ti ti-git-branch",
    //   bg: "bg-purple",
    // },
    {
      type: "app",
      label: "Calendar",
      link: route.calendar,
      icon: "ti ti-calendar",
      bg: "bg-danger",
    },
    {
      type: "app",
      label: "Todo",
      link: route.todo,
      icon: "bi bi-card-checklist",
      bg: "bg-tertiary",
    },
    {
      type: "app",
      label: "Notes",
      link: route.notes,
      icon: "bi bi-journal-bookmark",
      bg: "bg-green"
    },
    {
      type: "app",
      label: "Content Messages",
      link: route.contactMessages,
      icon: "ti ti-git-branch",
      bg: "bg-purple",
    },
  
    {
      type: "report",
      label: "Lead Report",
      link: route.leadReports,
      icon: "ti ti-report",
      bg: "bg-primary"

    },
    {
      type: "report",
      label: "Deal Report",
      link: route.dealReports,
      icon: "ti ti-file-dollar",
      bg: "bg-success"
    },
    {
      type: "report",
      label: "User Report",
      link: route.companyReports,
      icon: "ti ti-user",
      bg: "bg-info"
    },
  ],

  superadmin: [
    {
      type: "app",
      label: "Clients",
      link: route.superadminCompany,
      icon: "bi bi-buildings",
      bg: "bg-violet",
    },
    {
      type: "app",
      label: "Subscription",
      link: route.superadminSubscription,
      icon: "bi bi-cart-check",
      bg: "bg-secondary",
    },
    {
      type: "app",
      label: "Client Payments",
      link: route.superadminPayment,
      icon: "ti ti-report-money",
      bg: "bg-success",
    },
    {
      type: "app",
      label: "Packages",
      link: route.superadminPackagelist,
      icon: "bi bi-person-gear",
      bg: "bg-dark",
    },
    {
      type: "app",
      label: "Manage Users",
      link: route.manageusers,
      icon: "bi bi-person-gear",
      bg: "bg-info",
    },
  ],

  client: [],
};
